import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UserStoreService } from '@user-store';
import { mergeMap, of } from 'rxjs';
import { VehiclesService } from '../general/shared/services/vehicles/vehicles.service';
import { initAppSettings } from './app-settings.actions';
import { setDateFilter } from './date-filter/date-filter.actions';
import { setCombinedMode, setMode } from './mode-filter/mode-filter.actions';
import { setVehicles } from './vehicles-filter/vehicle-filter.actions';
import { setWorkflowShift } from './workflow-shift/workflow-shift.action';

@Injectable()
export class AppSettingsEffects {
	actions$ = inject(Actions);
	userStore = inject(UserStoreService);
	vehiclesService = inject(VehiclesService);

	loadAppSettings$ = createEffect(() =>
		this.actions$.pipe(
			ofType(initAppSettings),
			mergeMap(() => {
				const appSettings = this.userStore.currentAppSettings();
				if (!appSettings.selectedMachines || appSettings.selectedMachines.length === 0) {
					return of(
						setDateFilter({ value: appSettings.dateSelector }),
						setVehicles({ value: [] }),
						setMode({ value: appSettings.dateSelector.mode }),
						setCombinedMode({ value: appSettings.dateSelector.combined }),
						setWorkflowShift({ value: appSettings.dateSelector.workflowShift })
					);
				}
				return this.vehiclesService
					.loadVehicles(appSettings.selectedMachines)
					.pipe(
						mergeMap((selectedVehicles) =>
							of(
								setDateFilter({ value: appSettings.dateSelector }),
								setVehicles({ value: selectedVehicles }),
								setMode({ value: appSettings.dateSelector.mode }),
								setCombinedMode({ value: appSettings.dateSelector.combined }),
								setWorkflowShift({ value: appSettings.dateSelector.workflowShift })
							)
						)
					);
			})
		)
	);
}
